import { usePortalSession } from '@/features/releases/usePortalSession'
import { AvisoDeNovedades } from './AvisoDeNovedades'

/**
 * El aviso de novedades en la PORTADA pública (goal portal-correcciones 10,
 * decisión 1). Hasta ahora solo salía al entrar a `/app` —`AvisoDeNovedades`
 * cuelga de `AppShell`, dentro de `RequireAuth`—, así que quien llegaba a `/`
 * con su sesión de plataforma viva no se enteraba de nada.
 *
 * 🚨 **La guarda de sesión es obligatoria, no una optimización.** La petición
 * de novedades manda el `Bearer` del `tokenStore` (`novedades.ts`), y sin token
 * sale desnuda: el servidor la rechaza y el visitante anónimo pagaría una
 * llamada inútil en cada visita a la portada. Aquí no hay `RequireAuth` que lo
 * garantice, así que lo garantiza este componente.
 *
 * 🚨 **`isLoggedIn` reacciona al `tokenStore`** (`usePortalSession` usa
 * `useSyncExternalStore`), y eso importa: la adopción de la sesión de
 * plataforma (`AppProviders`) es ASÍNCRONA y termina DESPUÉS del primer
 * pintado. Con una lectura de una sola vez, quien llega con sesión viva no
 * vería nunca el aviso. El precedente exacto es `Footer.tsx`.
 *
 * 🚨 **Un solo componente montado en dos sitios, nunca a la vez**: la portada
 * (`PublicLayout` → `LandingPage`) y el shell autenticado son ramas hermanas
 * del router, así que no hay dos peticiones ni dos modales. Y quién lo ha visto
 * lo sigue decidiendo el SERVIDOR: cerrado aquí, no vuelve a salir en el
 * perfil, y al revés.
 */
export function NovedadesEnLaPortada() {
  const { isLoggedIn } = usePortalSession()

  if (!isLoggedIn) return null
  return <AvisoDeNovedades />
}
